import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { Observable, of } from 'rxjs';
import { map, startWith, switchMap } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';

@Component({
  selector: 'app-changing-consignee-dialog',
  templateUrl: './changing-consignee-dialog.component.html',
  styleUrls: ['./changing-consignee-dialog.component.scss']
})
export class ChangingConsigneeDialogComponent implements OnInit {
  consigneeForm: FormGroup;
  filteredConsigneeList: Observable<any[]> = of([]);
  addresses: any[] = [];

  constructor(
    public dialogRef: MatDialogRef<ChangingConsigneeDialogComponent>,
    private fb: FormBuilder,
    private http: HttpClient
  ) {
    this.consigneeForm = this.fb.group({
      new_consignee_control: [''],
      consignee_contact_uuid: [''],
      consignee_address_uuid: [''],
      consignee_name: [''],
      consignee_locality: [''],
      consignee_region: ['']
    });
  }

  ngOnInit(): void {
    this.setupConsigneeAutocomplete();
  }

  setupConsigneeAutocomplete() {
    this.filteredConsigneeList = this.consigneeForm.get('new_consignee_control')!.valueChanges.pipe(
      startWith(''),
      switchMap(value => {
        if (typeof value === 'string' && value.length >= 3) {
          return this.getConsigneeList(value);
        }
        return of([]);
      })
    );
  }

  getConsigneeList(query: string): Observable<any[]> {
    console.log(`query is -------------${query}-------------`);
    const url = `/api/work_orders/contact_autofill.php?type=consignee_contact_list&search=${query}`;
    return this.http.get<any[]>(url).pipe(
      map(response => response || [])
    );
  }

  getContactData(contact_uuid: string): Observable<any> {
    const url = `/api/work_orders/contact_autofill.php?type=contact_data&uuid=${contact_uuid}`;
    return this.http.get<any>(url).pipe(
      map(response => response[0] || {})
    );
  }

  displayFn(consignee: any): string {
    return consignee && consignee.label ? consignee.label : '';
  }

  onConsigneeSelected(selectedConsignee: any) {
    this.consigneeForm.get('consignee_contact_uuid')!.setValue(selectedConsignee.value);
    this.consigneeForm.get('consignee_name')!.setValue(selectedConsignee.label.split(' - ')[0]);

    // Fetch full shipper details
    this.http.get(`/api/work_orders/contact_autofill.php?type=contact_data&uuid=${selectedConsignee.value}`).subscribe((details: any) => {
      const data = details[0];
      if (data && data.addresses) {
        this.addresses = data.addresses;
        if (this.addresses.length > 0) {
          const defaultUuid = this.addresses[0].contact_address_uuid;
          this.consigneeForm.get('consignee_address_uuid')!.setValue(defaultUuid);
          this.onAddressSelected(defaultUuid);
        } else {
          console.warn('No addresses found for selected consignee.');
        }
      }
    }, error => {
      console.error('Error fetching consignee details:', error);
    });
  }

  onAddressSelected(addressUuid: string) {
    const addr = this.addresses.find(a => a.contact_address_uuid === addressUuid);
    if (addr) {
      this.consigneeForm.patchValue({
        consignee_locality: addr.locality,
        consignee_region: addr.region
      });
    }
  }

  onSubmit(): void {
    if (this.consigneeForm.valid) {
      this.dialogRef.close(this.consigneeForm.value);
    }
  }

  onCancel(): void {
    this.dialogRef.close();
  }
}